export function countries(state) {
  return state.countries
}


// WEBPACK FOOTER //
// ./src/modules/countries/getters.js